var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcChevronSingleRightmono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69844 15.9004C8.29844 16.3004 8.29844 16.9004 8.69844 17.3004C9.09844 17.7004 9.79844 17.7004 10.1984 17.3004L15.1984 12.7004C15.5984 12.3004 15.5984 11.7004 15.1984 11.3004L10.1984 6.70039C9.79844 6.30039 9.09844 6.30039 8.69844 6.70039C8.29844 7.10039 8.29844 7.7004 8.69844 8.1004L12.8984 12.0004L8.69844 15.9004Z",
    fill: "#FF0073"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcChevronSingleRightmono);
export default __webpack_public_path__ + "static/media/mai-ic-chevron-single-right.mono.9e28811bdda4afeabfc7cc3c7f888e66.svg";
export { ForwardRef as ReactComponent };